'use client'

import Image from 'next/image'
import s from './style.module.css'
import {useSidebar} from '@app/components/sidebar/sidebar-visiblity-context'
import clsx from 'clsx'

const HamburgerButton = ({isMobile}: {isMobile: boolean}) => {
  const {toggleSidebar, isOpen} = useSidebar()
  return (
    <button
      className={clsx(s.button, {
        [s.active]: isOpen,
        [s.inactive]: !isOpen,
        [s.desktop_button]: !isMobile,
      })}
      onClick={toggleSidebar}
    >
      <Image
        src='https://static.gamezop.com/comet/assets/img2/menu.svg'
        alt='menu button'
        width={18}
        height={12}
        className={clsx(s.menu_icon, {
          [s.desktop_menu_icon]: !isMobile,
        })}
      />
    </button>
  )
}

export default HamburgerButton
